import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core'
import ShowToRole from 'components/Common/Portal/ShowToRole'
import {
  ProjectStateAsString,
  ProjectStatus,
} from 'controllers/Project/ProjectStateMachine'
import { ProjectProcessFlow } from 'features/BillOfMaterials/ProjectHeader/ProjectProcessFlow'
import { projectStatusSelector } from 'features/BillOfMaterials/store/selectors/projectStatusSelector'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { RootAppState } from 'store/configureStore'
import './ProjectStatus.scss'
import { CancelledState } from './States/CancelledState'
import { ProductionStates } from './States/CurrentState'
import { DefiningState } from './States/DefiningState'
import { OrderState } from './States/OrderState'
import { QuotedState } from './States/QuoteState'
import { RequestState } from './States/RequestState'

const useStyles = makeStyles((theme: Theme) => {
  const disabledBackgroundColor = theme.palette.action.disabledBackground
  const disabledBorderColor = theme.palette.action.disabledBackground

  return createStyles({
    root: {
      '& li:after': {
        content: ' ',
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '.8em 0 .8em 16px',
        right: '-16px',
        top: 0,
        zIndex: '2',
        position: 'absolute',
      },
    },
    active: {
      backgroundColor: theme.palette.info.main,
      color: theme.palette.info.contrastText,
      '&:after': {
        borderColor: `transparent transparent transparent ${theme.palette.info.main}`,
      },
    },
    disabled: {
      backgroundColor: disabledBackgroundColor,
      '&:after': {
        borderColor: `transparent transparent transparent ${disabledBorderColor}`,
      },
    },
  })
})

export const InProductionProjectStatuses = [
  ProjectStateAsString.ORDERED,
  ProjectStateAsString.PRODUCING,
  ProjectStateAsString.PRODUCED,
  ProjectStateAsString.PACKAGING,
  ProjectStateAsString.PACKAGED,
  ProjectStateAsString.DELIVERING,
  ProjectStateAsString.DELIVERED,
]

export const ProjectStatusSelector = () => {
  const { t } = useTranslation()
  const cn = useStyles()

  const currentProjectStateFromStore = useAppSelector(projectStatusSelector)

  const definingInPortal = useAppSelector(
    (state: RootAppState) => state.project.activeProject?.definingInPortal
  )

  if (currentProjectStateFromStore === ProjectStateAsString.CANCELLED) {
    return (
      <div className="project-status">
        <CancelledState />
      </div>
    )
  }

  if (InProductionProjectStatuses.includes(currentProjectStateFromStore)) {
    return (
      <div className="project-status">
        <ul className={cn.root}>
          <ProductionStates showStatus={ProjectStatus.ORDERED} />

          <ProductionStates showStatus={ProjectStatus.PRODUCING} />
          {/* <CurrentState showStatus={ProjectStatus.PRODUCED} /> */}
          <ProductionStates showStatus={ProjectStatus.PACKAGING} />
          {/* <CurrentState showStatus={ProjectStatus.PACKAGED} /> */}
          <ProductionStates showStatus={ProjectStatus.DELIVERING} />
          {/* <CurrentState showStatus={ProjectStatus.DELIVERED} /> */}
        </ul>
      </div>
    )
  }

  return (
    <div className="project-status">
      <ul className={cn.root}>
        <DefiningState />
        <RequestState />
        <QuotedState />
        <OrderState />
      </ul>
      {definingInPortal && (
        <ShowToRole seller>
          <Typography variant="caption" style={{ marginLeft: '1rem' }}>
            {t('project:defined-in-portal', 'self-service portal')}
          </Typography>
        </ShowToRole>
      )}
      <ProjectProcessFlow style={{ marginLeft: '1rem' }} />
    </div>
  )
}
